import { get, intersection } from 'lodash';
import * as filters from '@/common/filters';
import { ObjectsTypesMap } from '@/store/application/data.assets';
import { featuresModule } from '../features';
import { satisfyListOrSingleFilterNumber } from './satisfy.event.filter';

export function satisfyEpisodeFilter(episode: any, filter: any, episodeType: string): boolean {
  let satisfy = true;
  const event = episode.last_face_event || episode.last_body_event || episode.last_car_event;

  if (satisfy && filter.has_face) {
    satisfy = !!(episode.best_face_event || episode.last_face_event);
  }

  if (satisfy && filter.has_body) {
    satisfy = !!(episode.best_body_event || episode.last_body_event);
  }

  if (satisfy && filter.id_in) {
    const id = String(episode.id);
    satisfy = Array.isArray(filter.id_in) ? (filter.id_in.length ? filter.id_in.includes(id) : true) : String(filter.id_in) === id;
  }

  if (satisfy && filter.matched_card_in) {
    satisfy = satisfyListOrSingleFilterNumber(filter.matched_card_in, episode.matched_card);
  }

  if (satisfy && filter.acknowledged) {
    satisfy = filter.acknowledged === 'True' ? episode.acknowledged : !episode.acknowledged;
  }

  if (satisfy && filter.has_face) {
    satisfy = !!(episode.best_face_event || episode.last_face_event);
  }

  if (satisfy && filter.has_body) {
    satisfy = !!(episode.best_body_event || episode.last_body_event);
  }

  if (satisfy && filter.matched_lists.length) {
    satisfy = intersection(filter.matched_lists, event.matched_lists).length > 0;
  }

  if (satisfy && filter.no_face_match) {
    const hasMatch = !!episode.matched_face_event;
    satisfy = filter.no_face_match === 'True' ? !hasMatch : hasMatch;
  }

  if (satisfy && filter.no_body_match) {
    const hasMatch = !!episode.matched_body_event;
    satisfy = filter.no_body_match === 'True' ? !hasMatch : hasMatch;
  }

  if (satisfy && filter.no_car_match) {
    const hasMatch = !!event.matched_card;
    satisfy = filter.no_car_match === 'True' ? !hasMatch : hasMatch;
  }

  if (satisfy && filter.camera_groups.length) {
    satisfy = filter.camera_groups.find((v: number) => v === event.camera_group);
  }

  if (satisfy && filter.cameras.length) {
    satisfy = !!filter.cameras.find((v: number) => v === event.camera);
  }

  if (satisfy && filter.created_date_gte) {
    let isoStringToDate = filters.isoStringToDate,
      filterGTEDate = isoStringToDate(filter.created_date_gte),
      eventDate = isoStringToDate(event.created_date);

    satisfy = eventDate.getTime() >= filterGTEDate.getTime();
  }

  if (satisfy && filter.created_date_lte) {
    let isoStringToDate = filters.isoStringToDate,
      filterLteDate = isoStringToDate(filter.created_date_lte),
      eventDate = isoStringToDate(event.created_date);

    satisfy = eventDate.getTime() <= filterLteDate.getTime();
  }

  if (satisfy && filter.events_count_gte) {
    satisfy = episode.events_count >= filter.events_count_gte;
  }

  if (satisfy && filter.video_archive?.length) {
    satisfy = satisfyListOrSingleFilterNumber(filter.video_archive, episode.video_archive);
  }

  if (episodeType === 'humans') {
    if (episode.last_face_event) satisfy = satisfy && featuresModule.satisfyFeaturePropsToFilters(episode.last_face_event.features, filter, ObjectsTypesMap.Faces);
    if (episode.last_body_event) satisfy = satisfy && featuresModule.satisfyFeaturePropsToFilters(episode.last_body_event.features, filter, ObjectsTypesMap.Bodies);
  } else {
    satisfy = satisfy && featuresModule.satisfyFeaturePropsToFilters(episode.last_car_event.features, filter, ObjectsTypesMap.Cars);
  }
  return satisfy;
}
